// FetchCookie.js

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
    return null; // Return null if the cookie is not found
}

const safeParseJSON = (str) => {
    try {
        return JSON.parse(str);
    } catch {
        return null;
    }
};

// Try to extract a token from a variety of common shapes
const extractToken = (obj) => {
    if (!obj || typeof obj !== "object") return null;
    return (
        obj.accessToken ||
        obj.access_token ||
        obj.token ||
        obj?.data?.token ||
        obj?.data?.accessToken ||
        obj?.user?.accessToken ||
        obj?.user?.access_token ||
        obj?.user?.token ||
        null
    );
};

/**
 * Returns an access token (string) or null.
 * - If cookie stores full JSON, extract from many common fields.
 * - If cookie is a raw JWT string (xxx.yyy.zzz), return it directly.
 */
export const fetchToken = async () => {
    const tokenCookie = getCookie("userToken");
    if (!tokenCookie) {
        console.log("userToken cookie not found");
        return null;
    }

    try {
        const decoded = decodeURIComponent(tokenCookie);
        const jsonObject = safeParseJSON(decoded);
        if (jsonObject) {
            const token = extractToken(jsonObject);
            return token || null;
        }

        // Fallback: if cookie is a raw JWT string, return it
        const looksLikeJWT = decoded.split(".").length === 3;
        return looksLikeJWT ? decoded : null;
    } catch (error) {
        console.log("Error in fetching token: ", error);
        return null; // Return null on error
    }
};

/**
 * Returns the parsed JSON user object or null.
 * If cookie is not valid JSON, returns null so routing treats it as unauthenticated.
 */
export const fetchCookie = async () => {
    const cookie = getCookie("userToken");
    if (!cookie) {
        console.log("userToken cookie not found");
        return null;
    }

    try {
        const decodedData = decodeURIComponent(cookie);
        const userObject = safeParseJSON(decodedData);
        return userObject || null;
    } catch (error) {
        console.log("Error in fetching user data: ", error);
        return null; // Return null on error
    }
};